import { classnames } from '@/utils/classnames/classnames';
import { cva } from '@/utils/classnames/cva';
import { UseClassNames } from '../types';

const useClassNames: UseClassNames = ({
  variant = 'primary',
  size = 's',
  className = '',
  includesIcon,
  iconPosition,
  loading,
  asSkeleton = false,
}) => {
  const resolveVariant = cva({
    intent: {
      primary: [
        'rounded-full bg-pink-500 px-4 py-3 text-14 font-bold uppercase leading-4 text-white-100 outline-offset-0 disabled:bg-pink-300',
        'active:bg-pink-500 active:shadow-button active:disabled:shadow-none',
        'border-pink-500 focus-visible:border focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-pink-500',
      ],
      secondary: [
        'rounded-full bg-pink-900 px-4 py-3 text-14 font-bold uppercase leading-4 text-white-100 outline-offset-0 disabled:bg-pink-300',
        'active:bg-pink-900 active:shadow-button active:disabled:shadow-none',
        'border-pink-900 focus-visible:border focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-pink-900',
      ],
      tertiary: [
        'rounded-full bg-primary px-4 py-3 text-14 font-bold uppercase leading-4 text-white-100 outline-offset-0 disabled:bg-secondary',
        'active:bg-primary active:shadow-button active:disabled:shadow-none',
        'border-primary focus-visible:border focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-primary',
      ],
      bordered: [
        'border border-white-400 bg-white-100 text-left text-primary hover:text-secondary focus:outline-none',
        'rounded-full px-4 py-3 text-14 font-bold uppercase leading-4',
      ],
      warning: [
        'bg-red-500 text-neutral-100 outline-offset-0',
        'hover:bg-red-600',
        'active:bg-red-500 active:shadow-button active:disabled:shadow-none',
        'focus-visible:border focus-visible:border-red-700 focus-visible:bg-red-700 focus-visible:outline focus-visible:outline-offset-[3px] focus-visible:outline-primary',
        'disabled:bg-neutral-400 disabled:text-neutral-100',
      ],
      underlined: 'pb-2 text-14 text-primary underline hover:text-secondary disabled:text-neutral-400',
      ghost: 'disabled:text-neutral-400',
    },
    size: {
      // xs: 'p-2 text-12',
      // s: 'px-6 py-2 text-14',
      // m: 'px-9 py-3 text-14',
      // l: 'px-12 py-3 text-16',
      fit: 'p-0',
      full: 'w-full',
      // icon: 'grid h-10 w-10 items-center justify-center',
    },
  });

  const buttonClassName = classnames(
    resolveVariant(`size.${size}`) as string,
    { 'flex items-center gap-1': includesIcon },
    { 'flex-row-reverse': includesIcon && iconPosition === 'left' },
    { 'cursor-not-allowed': !!loading },
    'relative overflow-hidden transition disabled:pointer-events-none',
    asSkeleton ? 'relative' : (resolveVariant(`intent.${variant}`) as string),
    className,
  );

  return buttonClassName;
};

export default useClassNames;
